import { useQuery } from '@tanstack/react-query';
import { dealEventLogControllerGetDealEventMessageOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { formatMessageDates } from '@dealstack/frontend/app/pages/Project/MIP/Messages/Messages.utils';
import { dealEventLogRequestOptions } from '@dealstack/frontend/app/pages/Project/DealEventLog/useDealEventLogUnread.ts';

/** The feed's own read of a message, scoped to the deal rather than to a programme's investor. */
export const useDealEventMessage = (dealId: string, messageId: string) =>
	useQuery({
		...dealEventLogControllerGetDealEventMessageOptions({
			...dealEventLogRequestOptions(dealId),
			path: { messageId },
		}),
		enabled: !!dealId && !!messageId,
		select: formatMessageDates,
	});
